var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showTip)?_c('div',{staticClass:"oversea-tip row"},[_c('img',{attrs:{"src":_vm.ALERT_ICON}}),_c('div',[_vm._v(_vm._s(_vm.overseaInfo.delayText))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }